import {
  createFileRoute,
  useRouteContext,
  Navigate,
  Outlet,
  useLocation,
} from '@tanstack/react-router';
import PublicLayout from '~/components/layouts/PublicLayout/PublicLayout';

const PublicComponent = () => {
  const context = useRouteContext({
    from: '__root__',
  });
  const location = useLocation();

  // Check if authenticated user is accessing a mayoclinic store page
  const isAccessingMayoclinicStore = () => {
    return location.pathname.match(/^\/mayoclinic\/store\/(.+)$/);
  };

  // Allow authenticated practitioners to view any mayoclinic store page
  if (
    context.isAuthenticated &&
    context.isPractitioner &&
    isAccessingMayoclinicStore()
  ) {
    // Allow access to mayoclinic store pages for authenticated practitioners
  } else if (context.isAuthenticated) {
    // Redirect other authenticated users (non-practitioners) to portal
    return <Navigate to='/portal' />;
  }

  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
};

export const Route = createFileRoute('/_public')({
  component: PublicComponent,
});
